export default __webpack_public_path__ + "static/media/addon9.0c062585.webp";